// /sso/gpt - hands the signed-in session to gpt.bidlight.com (back/routes/ssoGpt.js).
// Signed out, the app's catch-all sends people through /authorization and
// back here (App.jsx: the signed-in /authorization route follows the
// remembered destination).
//
// A session this browser still holds but the server no longer accepts
// (signed out everywhere, password changed, expired early) answers 401: that
// is "sign in again", not an error page - the stored session is dropped and
// the person goes through the login page and back here with the same state.
import React, { useEffect, useRef, useState } from "react";
import {
  url, tokenRef, user_permissionsRef, company_permissionsRef, all_permissionsRef,
  coordination_onlyRef, primary_packageRef,
} from "api/index";
import logo from "assets/images/logo/logo-blue.png";

export const signInAgainPath = (state) => `/authorization?next=${encodeURIComponent(`/sso/gpt?state=${state}`)}`;

const SsoGpt = ({ location }) => {
  const [error, setError] = useState("");
  // One code per state: the login page and the /authorization redirect can
  // both land here, and a second code would only race the first.
  const asked = useRef("");
  useEffect(() => {
    const state = new URLSearchParams((location && location.search) || "").get("state") || "";
    if (asked.current === state) return;
    asked.current = state;
    let token = "";
    try { token = localStorage.getItem(tokenRef) || ""; } catch (e) { token = ""; }
    fetch(`${url}/sso/gpt/code`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ state }),
    })
      .then(async (res) => {
        if (res.status === 401) {
          try {
            [tokenRef, user_permissionsRef, company_permissionsRef, all_permissionsRef, coordination_onlyRef, primary_packageRef]
              .forEach((k) => localStorage.removeItem(k));
          } catch (e) { /* storage unavailable */ }
          window.location.replace(signInAgainPath(state));
          return;
        }
        const r = await res.json().catch(() => ({}));
        if (res.ok && r && r.redirect && /^https:\/\/gpt\.bidlight\.com\//.test(r.redirect)) window.location.replace(r.redirect);
        else setError((r && r.err) || "Could not continue to BidLight GPT.");
      })
      .catch(() => setError("Could not continue to BidLight GPT."));
  }, [location]);
  return (
    <div style={{ minHeight: "calc(70 * var(--vh))", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, fontFamily: "Poppins, Nunito, sans-serif", color: "#3d5a72" }}>
      <img src={logo} alt="BidLight" width={64} height={64} />
      {error ? (
        <>
          <div>{error}</div>
          <a href="https://gpt.bidlight.com/login">Back to BidLight GPT</a>
        </>
      ) : (
        <div>Signing you in to BidLight GPT...</div>
      )}
    </div>
  );
};

export default SsoGpt;
